const EMAIL_LABELS = [
  {key: 'campaign/winnerSubject', type: 'string', label: 'InterfaceForm.winnerSubject', required: true},
  {key: 'campaign/winnerEmail', type: 'wysiwyg', label: 'InterfaceForm.winnerEmail', required: true},
  {key: 'campaign/loserSubject', type: 'string', label: 'InterfaceForm.loserSubject', required: true},
  {key: 'campaign/loserEmail', type: 'wysiwyg', label: 'InterfaceForm.loserEmail', required: true},
];

export default EMAIL_LABELS;
